<div class="card shadow p-4 min-h-[270px]">
  <nz-skeleton
    [ngClass]="loading ? 'p-3' : 'p-0'"
    [nzLoading]="loading"
    [nzActive]="true"
  >
    <span class="text-black title">QRISLY</span>
    <hr>
    <div class="flex flex-col md:flex-row items-center gap-1 w-full mt-2">
      <app-stat-card *ngFor="let card of cardsQrisly" [card]="card" class="col-12 col-md-6"></app-stat-card>
    </div>
  </nz-skeleton>
</div>
